/**
 * @namespace Plugins
 * @category Plugins
 * @module vue-services
 */

import Vue from 'vue'
import * as geocodingService from '@/services/geocoding-service.js'
import store from '@/store'
import * as authService from '@/services/auth-service.js'
import envService from '@/services/env-service.js'
import appService from '@/services/app-service.js'
import loggingService from '@/services/logging-service.js'
import exportService from '@/services/export-service.js'
import vehicleService from '@/services/vehicle-service.js'
import mapService from '@/services/map-service.js'
import newsService from '@/services/news-service.js'

export const geocodingPlugin = {
  autocompleteFetchPlaceDetails: (query, options) =>
    geocodingService.autocompleteFetchPlaceDetails(query, options),
  autocompleteFetchPlaces: (query, options) =>
    geocodingService.autocompleteFetchPlaces(query, options),
  /**
   * Fallback using the first basemapId found if a fake id is provided
   * @param {Number|String} id Active basemap basemapId
   * @returns {Number|String} Computed basemapId
   */
  _computeBasemapId: (id) => {
    if (!id || id.toString() === '-1' || id.toString().includes('_')) {
      return store.getters['settings/getValidBasemapId']
    } else {
      return id
    }
  },
  forwardGeocoding(options) {
    return geocodingService.forwardGeocoding(
      this._computeBasemapId(store.state.settings.wmsItem?.id),
      options
    )
  },
  reverseGeocoding(options) {
    return geocodingService.reverseGeocoding(
      this._computeBasemapId(store.state.settings.wmsItem?.id),
      options
    )
  },
  routingGeocoding(options) {
    return geocodingService.routingGeocoding(
      this._computeBasemapId(store.state.settings.wmsItem?.id),
      options
    )
  },
}

/**
 * Expose Simpliciti services (@/services)
 *
 * @todo: Extract service plugin (i.g $geocoding) into a new file if it gets big.
 */
Vue.use({
  install() {
    Vue.$services =
      Vue.prototype.$services =
      Vue.prototype.$srv =
        {
          geocodingService,
          geoSrv: geocodingService,
        }

    Vue.prototype.$env =
      Vue.$env =
      Vue.prototype.$envService =
      Vue.$envService =
        envService
    Vue.prototype.$appService = Vue.$appService = appService
    Vue.prototype.$loggingService = Vue.$loggingService = loggingService
    Vue.$vehicleService = Vue.prototype.$vehicleService = vehicleService
    Vue.prototype.$exportService = Vue.$exportService = exportService
    Vue.prototype.$mapService = Vue.$mapService = mapService
    Vue.prototype.$newsService = newsService

    /**
     * Wraper on top auth service
     */
    Vue.$auth = Vue.prototype.$auth = authService

    /**
     * Wrapper on top geocoding service (injects basemapId from settings store)
     * @todo Move to separate file geocoding-plugin.js
     */
    Vue.$geocoding = Vue.prototype.$geocoding = geocodingPlugin
  },
})
